import { deleteDependenceChild, deleteCompound } from '../../../indexDB/dependencies.js';
export default {
	methods: {
        /**
         * Resetea la data
         */
		async resetData () {
		    await this.getAllQuestions();
		    await this.getDependencies();
		    this.getDependenciesCompound();

		    if(this.questionsByPage[this.indexQuestion].properties) {
		    	if(this.questionsByPage[this.indexQuestion].properties.minValue){
		    		this.answerNum = this.questionsByPage[this.indexQuestion].properties.minValue;
		    	}
		    }

		    this.answer = '';

		    this.selectedQuestions = [];
		    this.selectedQuestionComputed = '';
		},
        /**
         * Desvincula una pregunta de una depedndencia bstandard.
         * @param {String} nameChild - ID de la pregunta a desvincular (P_X)
         */
		async deleteDependence(nameChild) {
		    await deleteDependenceChild(this.nameDad, nameChild);
		    await this.resetData();
		    await this.getCreatedDependencies();
		},
        /**
         * Desvincula una pregunta de la dependencia compuesta.
         * @param {String} nameChild - ID de la pregunta a desvincular (P_X)
         */
		async deleteDependenceCompound(nameChild) {
		    await deleteCompound(this.nameDad, nameChild);
		    await this.resetData();
		},
		change_tab1() {
		    this.isDependence = false;
		    this.answer = '';

		    if(this.questionsByPage[this.indexQuestion].properties) {
		    	if(this.questionsByPage[this.indexQuestion].properties.minValue){
		    		this.answerNum = this.questionsByPage[this.indexQuestion].properties.minValue;
		    	}
		    }
		},
		change_tab2() {
		    this.isDependence = true;
		    this.answerNum = 0;
		    this.answer = '';
		}
	},
	computed: {
        /**
         * Obtiene un array de las dependencias según la relación seleccionada.
         * @returns { Array }
         */
		filterQuestion() {
		    if(this.typeRelated === 'Standar') return this.filterQuestionStandar;
		    return this.filterQuestionCompuesta;
		},
		getFilterDependencies() {
		    if(this.typeRelated === 'Standar') return this.filterDependence;
		    return this.filterDependenceCompound;
		},
		isComputed() {
		    if(this.typeRelated === 'Compuesta') return true;
		    return false;
		},
		filterQuestionSearch() {
			if(this.searchQuestion.trim().length > 0) {
				return this.filterQuestion.filter(question => question.name.toLowerCase().includes(this.searchQuestion.toLowerCase()) || question.label.toLowerCase().includes(this.searchQuestion.toLowerCase()))
			}else return this.filterQuestion;
		}
	}
}
